import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { mapProps } from '../../../../../util/hocs';
import withModal from '../../../../../components/global/modal/withModal';
import Button from '../../../../../components/global/Button';

export const CARD_ELEMENT_PHOTO_PPI_WARNING_MODAL =
  'CARD_ELEMENT_PHOTO_PPI_WARNING_MODAL';

const propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onPersistentDismiss: PropTypes.func.isRequired,
};

const CardElementPhotoPpiWarningModalComponent = ({
  className,
  onClose,
  onPersistentDismiss,
}) => {
  const classes = classNames({
    [className]: !!className,
    'text-center': true,
  });

  return (
    <div className={classes}>
      <h3>Heads up!</h3>

      <p>
        This photo looks to be a bit small for this print size and might result
        in a lower quality print. Try to zoom out a bit or perhaps choose a
        different photo.
      </p>

      <Button onClick={onClose} className="mt-1 px-4 py-1">
        Got it
      </Button>
      <Button
        btnStyle="link"
        btnBlock
        className="mt-2"
        onClick={() => {
          onPersistentDismiss();
          onClose();
        }}
      >
        Never show this again
      </Button>
    </div>
  );
};

CardElementPhotoPpiWarningModalComponent.propTypes = propTypes;

const CardElementPhotoPpiWarningModal = withModal(
  mapProps(({ onClose, onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onClose || onRequestClose,
    ...actionProps,
    ...props,
  }))(CardElementPhotoPpiWarningModalComponent),
  {
    name: CARD_ELEMENT_PHOTO_PPI_WARNING_MODAL,
    size: 'xs',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'card-element-photo-ppi-warning-modal',
  },
);

export default CardElementPhotoPpiWarningModal;
